import { render } from "./EditObservationList.vue?vue&type=template&id=6d726aec&scoped=true"
import script from "./EditObservationList.vue?vue&type=script&lang=js"
export * from "./EditObservationList.vue?vue&type=script&lang=js"

import "./EditObservationList.vue?vue&type=style&index=0&id=6d726aec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d726aec"]])

export default __exports__